export const PLP_EVENTS = {
  MP_TITPTILE_CLICKED: 'tiptile_clicked',
  MP_PLP_FIRST_CLICK_INTERACTION: 'plp_first_click_interaction',
  MP_PLP_FIRST_CLICK_INTERACTION_NEW: 'plp_first_interaction_new',
  VIEW_SIMILAR_CLICKS: 'view_similar_clicks',
  SEARCH_PAGELOAD: 'search_listing_loads',
  CATEGORY_PAGELOAD: 'category_listing_loads',
  FILTER_APPLIED: 'filter_applied',
  SORT_APPLIED: 'sort_applied',
  QUICK_FILTERS_SHOWN: 'plp_quick_filters_shown',
  QUICK_FILTER_SELECTED: 'plp_quick_filters_selected',
  QUICK_FILTER_UNSELECTED: 'plp_quick_filters_unselected',
  CAROUSEL_FIRST_IMAGE_SWIPED: 'plp_image_swiped',
  OFFER_LISTING_PAGE_LOADS: 'offer_listing_page_loads',
  PLP_FILTER_CLEAR: 'plp_filter_cleared',
  PLP_PAGINATION_LOADED: 'plp_pagination_loaded',
  PLP_NO_RESULTS: 'plp_no_results',
  SEARCH_NO_RESULTS: 'search_no_results',
  PLP_REFINE_BACK_USED: 'plp_refine_back_used',
  RELATED_SEARCHES_WIDGET_CLICK: 'related_searches_widget_click',
};

export const PLP_INTERACTION = {
  PRODUCT: 'productImageCard',
  VIEW_SIMILAR: 'viewSimilar',
  WISHLIST: 'wishlist',
  TIP_TILE: 'tipTile',
  RELATED_SEARCHES: 'relatedSearches',
};

export const SEARCH = 'search';

export const BRAND_LISTING_PAGE = 'brandListingPage';
export const CATEGORY_LISTING_PAGE = 'categoryListingPage';

export const LISTING_PAGE_TYPE = {
  COUPON_LISTING_PAGE: 'couponListingPage',
  OFFER_LISTING_PAGE: 'offerListingPage',
  OFFER_PAGE: 'offerPage',
};
